<template>
  <div class="sidebar-app-container">
    <SidebarContainer :onToggleMenu="onSwitchToggleMenu" :class="sidebarCustomClass()">
      <Sidebar
        class="sidebar"
        :onClose="onCloseToggleMenu"
        :isMobileMenuShowing="stateSidebar.isMobileMenuShowing"
      >
        <router-link :to="'/'" class="sidebar-brand" slot="sidebar-brand">
          <img src="@/assets/image/logo-lighthouse.png" class="logo mr-2" width="24" />
          <span>
            Lighthouse
            <small>beta</small>
          </span>
        </router-link>
        <div class="sidebar-item sidebar-item-user" slot="sidebar-user">
          <UserMenu
            @toggleUserMenu="toggleUserMenu"
            :isToggleUserMenu="state.isToggleUserMenu"
            :currentUser="currentUser"
            :showUserMenu="true"
          >
            <template v-slot:submenu>
              <div class="menu-sub-item-container" v-if="state.isToggleUserMenu">
                <div class="menu-sub-divide">ข้อมูลส่วนตัว</div>
                <div class="menu-sub-item user-item">
                  <label>Team</label>
                  <div class="user-item-value">{{currentUser.team.name || '-'}}</div>
                </div>
                <div class="menu-sub-item user-item" v-if="currentUser.team">
                  <label>Email</label>
                  <div class="user-item-value">{{currentUser.email}}</div>
                </div>
                <div class="menu-sub-divide">ส่วนจัดการ</div>
                <a class="menu-sub-item" :href="`${baseURL}/accounts/logout?team=${teamName}`">
                  <i class="fas fa-sign-out-alt icon"></i>&nbsp;Logout
                </a>
              </div>
            </template>
          </UserMenu>
        </div>
        <div class="sidebar-item sidebar-item-project" slot="sidebar-project">
          <ProjectMenuSidebar
            class="menu-container"
            @isToggleSubmenu="toggleProjectSidebarMenu"
            :isToggleSubmenu="state.istoggleProjectSidebarMenu"
            :project="currentProject"
            :projectTitle="projectTitle"
            :showProjectConfig="true"
          >
            <template v-slot:projectsubmenu>
              <div class="menu-sub-item-container">
                <div class="menu-sub-divide">โปรเจกต์</div>
                <router-link
                  class="menu-sub-item"
                  :to="`/${teamName}/projects/${id}/summary`"
                  v-for="(id, index) in projectIds"
                  :key="`${id}${index}`"
                >
                  {{getProjectTitle(id)}}
                  <i class="fas fa-circle icon status"></i>
                </router-link>
                <div class="menu-sub-divide">ส่วนจัดการโปรเจกต์</div>
                <router-link
                  :to="`/${teamName}/projects/${currentProject.projectId}/settings`"
                  class="menu-sub-item"
                >
                  <i class="fas fa-cog icon"></i>ตั้งค่าโปรเจกต์
                </router-link>
                <router-link :to="`/${teamName}/projects/create`" class="menu-sub-item">
                  <i class="fas fa-plus icon"></i>สร้างโปรเจกต์ใหม่
                </router-link>
              </div>
            </template>
          </ProjectMenuSidebar>
        </div>
        <router-link
          v-for="(menu, index) in sidebarMenu"
          :key="index"
          :to="menu.link"
          class="sidebar-item"
          :class="{'router-link-active': isActiveMenu(menu.key),
          'sidebar-item-disabled': isEmptyProjects,
          'sidebar-item-first': index === 0 }"
          :title="generateMenuTitle(menu.key)"
          :event="disabledMenu()"
        >
          <span v-html="menu.titleHTML"></span>
        </router-link>
      </Sidebar>
    </SidebarContainer>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import SidebarContainer from '@/components/SidebarContainer.vue';
import Sidebar from '@/components/Sidebar.vue';
import UserMenu from '@/components/UserMenu.vue';
import ProjectMenuSidebar from '@/components/ProjectMenuSidebar.vue';

export default {
  props: {
    onToggleMenu: {
      type: Function,
      default: () => {},
    },
    stateSidebar: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      state: {
        isToggleUserMenu: false,
        istoggleProjectSidebarMenu: false,
      },
    };
  },
  components: {
    UserMenu,
    ProjectMenuSidebar,
    SidebarContainer,
    Sidebar,
  },
  watch: {
    customClass(value) {
      if (value) {
        document.body.className = 'modal-opened';
      } else {
        document.body.className = '';
      }
    },
  },
  computed: {
    ...mapGetters([
      'isEmptyProjects',
      'currentUser',
      'currentProject',
      'projectIds',
      'getProjectById',
    ]),
    teamName() {
      return this.$route.params.teamName;
    },
    projectId() {
      return this.$route.params.projectId;
    },
    projectTitle() {
      return _.get(this.currentProject, 'title', '');
    },
    sidebarMenu() {
      return [
        {
          key: 'summary',
          titleHTML: '<i class="fas fa-chart-bar icon"></i> Summary',
          link: `/${this.teamName}/projects/${this.projectId}/summary`,
        },
        {
          key: 'performance',
          titleHTML: '<i class="fas fa-chart-line icon"></i> Performance',
          link: `/${this.teamName}/projects/${this.projectId}/performance`,
        },
        {
          key: 'issues',
          titleHTML: '<i class="fas fa-layer-group icon"></i> Issues',
          link: `/${this.teamName}/projects/${this.projectId}/issues`,
        },
        {
          key: 'playbacks',
          titleHTML: '<i class="fas fa-lightbulb icon"></i> Playback Insight',
          link: `/${this.teamName}/projects/${this.projectId}/playbacks`,
        },
      ];
    },
    baseURL() {
      return process.env.VUE_APP_ORIGIN || window.location.origin;
    },
  },
  methods: {
    getProjectTitle(projectId) {
      const project = this.getProjectById(projectId);
      return project.title;
    },
    isShowCurrentProject() {
      if (!this.projectId) {
        return true;
      }
      return (
        this.projectId
        && this.getProjectById(this.projectId)
        && this.currentProject
      );
    },
    toggleUserMenu() {
      this.state.isToggleUserMenu = !this.state.isToggleUserMenu;
    },
    toggleProjectSidebarMenu() {
      this.state.istoggleProjectSidebarMenu = !this.state
        .istoggleProjectSidebarMenu;
    },
    sidebarCustomClass() {
      if (this.stateSidebar.isMobileMenuShowing) {
        return 'menu-showing';
      }
      return '';
    },
    isActiveMenu(currentMenu) {
      return currentMenu === this.$route.name;
    },
    generateMenuTitle(title) {
      if (this.isEmptyProjects) {
        return 'กรุณาสร้างโปรเจกต์ก่อนใช้งาน';
      }
      return title;
    },
    disabledMenu() {
      if (this.isEmptyProjects) {
        return '';
      }
      return 'click';
    },
    onSwitchToggleMenu() {
      this.onToggleMenu(!this.stateSidebar.isMobileMenuShowing);
    },
    onCloseToggleMenu() {
      this.onToggleMenu(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.sidebar-app-container {
  height: 100%;
}
</style>
